import { Box, Stack, alpha, useTheme, Typography } from '@mui/material';

import { Iconify } from 'src/components/iconify';

const TRIGGER_ICONS: Record<string, string> = {
  MANUAL: 'solar:hand-stars-bold',
  MESSAGE_RECEIVED: 'solar:chat-round-dots-bold',
  CONVERSATION_CREATED: 'solar:chat-square-bold',
  CONTACT_CREATED: 'solar:user-plus-bold',
  WEBHOOK: 'solar:link-bold',
  SCHEDULE: 'solar:calendar-minimalistic-bold',
};

type Props = {
  trigger: any;
  t: (key: string) => string;
};

export function RowCellWorkflowTrigger({ trigger, t }: Props) {
  const theme = useTheme();
  const triggerType = trigger?.type ?? 'MANUAL';
  const triggerIcon = TRIGGER_ICONS[triggerType] || 'solar:bolt-bold';

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Box
        sx={{
          width: 28,
          height: 28,
          borderRadius: '6px',
          bgcolor: alpha(theme.palette.primary.main, 0.08),
          color: 'primary.main',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Iconify icon={triggerIcon} width={16} />
      </Box>
      <Typography variant="body2" sx={{ fontWeight: 600, fontSize: 13, whiteSpace: 'nowrap' }}>
        {t(triggerType)}
      </Typography>
    </Stack>
  );
}
